import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c905f1c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "exporter"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "Export chart"), /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle"
}, "Select any format according to your needs")], -1));
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "body"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "padding": "10px",
    "background": "white",
    "border-radius": "1px",
    "outline": "1px #E3E3E3 solid",
    "outline-offset": "-0.50px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "12px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "3px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "140px",
    "padding-left": "4px",
    "padding-right": "4px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#595959",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "8px",
    "word-wrap": "break-word"
  }
}, " Title")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "42px",
    "padding-left": "6px",
    "padding-right": "6px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999999",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "9.60px",
    "word-wrap": "break-word"
  }
}, " Logo")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "flex": "1 1 0",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "20px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "117.75px",
    "align-self": "stretch",
    "position": "relative",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "align-self": "stretch",
    "background": "#E0ECFF",
    "border-radius": "3px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "left": "34.50px",
    "top": "51px",
    "position": "absolute",
    "color": "#134890",
    "font-size": "13px",
    "font-family": "Figtree",
    "font-weight": "500",
    "line-height": "15.60px",
    "word-wrap": "break-word"
  }
}, " 1:1 chart")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "align-self": "stretch",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "flex-start",
    "gap": "10px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40px",
    "height": "10px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "117.38px",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "6px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45.52px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "99.09px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
})])])])], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "padding": "10px",
    "background": "white",
    "border-radius": "1px",
    "outline": "1px #E3E3E3 solid",
    "outline-offset": "-0.50px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "12px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "3px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "140px",
    "padding-left": "4px",
    "padding-right": "4px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#595959",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "8px",
    "word-wrap": "break-word"
  }
}, " Title")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "42px",
    "padding-left": "6px",
    "padding-right": "6px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999999",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "9.60px",
    "word-wrap": "break-word"
  }
}, " Logo")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "flex": "1 1 0",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "20px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "156.67px",
    "align-self": "stretch",
    "position": "relative",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "157px",
    "align-self": "stretch",
    "background": "#E0ECFF",
    "border-radius": "3px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "left": "51.83px",
    "top": "50.88px",
    "position": "absolute",
    "color": "#134890",
    "font-size": "13px",
    "font-family": "Figtree",
    "font-weight": "500",
    "line-height": "15.60px",
    "word-wrap": "break-word"
  }
}, " 4:3 chart")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "align-self": "stretch",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "flex-start",
    "gap": "10px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40px",
    "height": "10px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "6px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.55px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "45.52px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "99.09px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
})])])])], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "padding": "10px",
    "background": "white",
    "border-radius": "1px",
    "outline": "1px #E3E3E3 solid",
    "outline-offset": "-0.50px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "12px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "3px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "140px",
    "padding-left": "4px",
    "padding-right": "4px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#595959",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "8px",
    "word-wrap": "break-word"
  }
}, " Title")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "42px",
    "padding-left": "6px",
    "padding-right": "6px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999999",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "9.60px",
    "word-wrap": "break-word"
  }
}, " Logo")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "flex": "1 1 0",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "16px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "8px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "position": "relative",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.31px",
    "align-self": "stretch",
    "background": "#E0ECFF",
    "border-radius": "3px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "left": "17.66px",
    "top": "50.88px",
    "position": "absolute",
    "color": "#134890",
    "font-size": "13px",
    "font-family": "Figtree",
    "font-weight": "500",
    "line-height": "15.60px",
    "word-wrap": "break-word"
  }
}, " 3:4 chart")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "position": "relative",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "88.31px",
    "align-self": "stretch",
    "background": "#E0ECFF",
    "border-radius": "3px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "left": "17.66px",
    "top": "50.88px",
    "position": "absolute",
    "color": "#134890",
    "font-size": "13px",
    "font-family": "Figtree",
    "font-weight": "500",
    "line-height": "15.60px",
    "word-wrap": "break-word"
  }
}, " 3:4 chart")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "align-self": "stretch",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "flex-start",
    "gap": "10px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40px",
    "height": "10px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "68.76px",
    "height": "4px",
    "background": "#F4F4F4",
    "border-radius": "1px"
  }
})])])])], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "padding": "10px",
    "background": "white",
    "border-radius": "1px",
    "outline": "1px #E3E3E3 solid",
    "outline-offset": "-0.50px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "12px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "align-self": "stretch",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "3px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "70px",
    "height": "4px",
    "background": "#D9D9D9",
    "border-radius": "1px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "140px",
    "padding-left": "4px",
    "padding-right": "4px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    "gap": "4px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#595959",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "8px",
    "word-wrap": "break-word"
  }
}, " Title")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "42px",
    "padding-left": "6px",
    "padding-right": "6px",
    "padding-top": "2px",
    "padding-bottom": "2px",
    "background": "#F4F4F4",
    "border-radius": "2px",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#999999",
    "font-size": "8px",
    "font-family": "Figtree",
    "font-weight": "600",
    "line-height": "9.60px",
    "word-wrap": "break-word"
  }
}, " Logo")])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 1 0",
    "position": "relative",
    "justify-content": "flex-start",
    "align-items": "center",
    "gap": "4px",
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "280px",
    "align-self": "stretch",
    "background": "#E0ECFF",
    "border-radius": "3px"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "left": "110px",
    "top": "50.88px",
    "position": "absolute",
    "color": "#134890",
    "font-size": "13px",
    "font-family": "Figtree",
    "font-weight": "500",
    "line-height": "15.60px",
    "word-wrap": "break-word"
  }
}, " 2.3:1 chart")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_clear_icon = _resolveComponent("clear-icon");
  const _component_evolution_chart_export_option = _resolveComponent("evolution-chart-export-option");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createBlock(_component_b_modal, {
    class: "evolution-chart-export-modal",
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $options.modal = $event),
    centered: "",
    "no-fade": "",
    "hide-footer": "",
    "hide-header": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_clear_icon, {
      class: "clear-icon",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', false))
    })])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_evolution_chart_export_option, {
      title: "Square",
      onCopy: _cache[1] || (_cache[1] = showAxes => $options.handleCopy($data.EXPORT_SIZES.SQUARE, showAxes, $data.EXPORT_LIMITS.SQUARE)),
      onCopyNoBackground: _cache[2] || (_cache[2] = showAxes => $options.handleCopyNoBackground($data.EXPORT_SIZES.SQUARE, showAxes, $data.EXPORT_LIMITS.SQUARE))
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_evolution_chart_export_option, {
      title: "Landscape rectangle",
      onCopy: _cache[3] || (_cache[3] = showAxes => $options.handleCopy($data.EXPORT_SIZES.LANDSCAPE_RECTANGLE, showAxes, $data.EXPORT_LIMITS.LANDSCAPE_RECTANGLE)),
      onCopyNoBackground: _cache[4] || (_cache[4] = showAxes => $options.handleCopyNoBackground($data.EXPORT_SIZES.LANDSCAPE_RECTANGLE, showAxes, $data.EXPORT_LIMITS.LANDSCAPE_RECTANGLE))
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_evolution_chart_export_option, {
      title: "Portrait rectangle",
      onCopy: _cache[5] || (_cache[5] = showAxes => $options.handleCopy($data.EXPORT_SIZES.PORTRAIT_RECTANGLE, showAxes, $data.EXPORT_LIMITS.PORTRAIT_RECTANGLE)),
      onCopyNoBackground: _cache[6] || (_cache[6] = showAxes => $options.handleCopyNoBackground($data.EXPORT_SIZES.PORTRAIT_RECTANGLE, showAxes, $data.EXPORT_LIMITS.PORTRAIT_RECTANGLE))
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }), _createVNode(_component_evolution_chart_export_option, {
      title: "Full width",
      onCopy: _cache[7] || (_cache[7] = showAxes => $options.handleCopy($data.EXPORT_SIZES.FULL_WIDTH, showAxes, $data.EXPORT_LIMITS.FULL_WIDTH)),
      onCopyNoBackground: _cache[8] || (_cache[8] = showAxes => $options.handleCopyNoBackground($data.EXPORT_SIZES.FULL_WIDTH, showAxes, $data.EXPORT_LIMITS.FULL_WIDTH))
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["modelValue"]);
}